// extracted by mini-css-extract-plugin
export var close = "PopUp-module--close--iuVFl";
export var closeWrapper = "PopUp-module--close-wrapper--2FYLi";
export var content = "PopUp-module--content--v72Fu";
export var popup = "PopUp-module--popup--x1NzY";
export var popupOverlay = "PopUp-module--popup-overlay--40-iz";
export var popupOverlayShow = "PopUp-module--popup-overlay-show--iwlds";
export var popupTitle = "PopUp-module--popup-title--S0Mf0";
export var title = "PopUp-module--title--8bjTu";